import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import type { Role } from '../models/role.model';
import { isRole } from '../models/role.model';
import { AuthService } from '../services/auth.service';

function readRequiredRoles(data: unknown): Role[] {
  if (!data || typeof data !== 'object') return [];
  const raw = (data as { roles?: unknown }).roles;
  if (!Array.isArray(raw)) return [];
  return raw.filter(isRole);
}

export const roleGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const required = readRequiredRoles(route.data);
  if (required.length === 0) {
    return true;
  }
  const current = authService.role();
  if (!current) {
    return router.createUrlTree(['/login']);
  }
  return required.includes(current) ? true : router.createUrlTree(['/forbidden']);
};
